/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GrInstagram, GrLinkedin, GrFacebookOption } from "react-icons/gr";

const Footer = ({ homePage }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 475);
    };

    // Check on initial render
    handleResize();

    // Listen for resize events
    window.addEventListener("resize", handleResize);

    // Cleanup event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div>
      <section className={isMobile && homePage ? "-mt-96" : ""}>
        <div className="footer">
          <div className=" footer-grid grid-2 md:flex">
            <div
              id="w-node-_5b3d2ba0-53c8-ba4d-6138-c048d224e3e9-3890e283"
              className="footer-block md:w-[150%]"
            >
              <a href="#" className="footer-brand margin-top-20 w-inline-block">
                <a
                  href="#"
                  className="footer-brand margin-top-20 w-inline-block border50"
                >
                  <img
                    width="32"
                    loading="lazy"
                    alt=""
                    src="/images/High_Table_Logo.png"
                  />
                </a>
                <h4 className="footer-heading margin-top-20 footerTitile ml-2">
                  HighTable
                </h4>
              </a>

              {/* <h4 className="footer-heading margin-top-20 footerTitile">
                HighTable
              </h4> */}
              <p className="body-text mb-3">
                HighTable is a unique social experience where 4–10 people come together over a shared meal and meaningful conversation. It’s a space that invites openness — where stories unfold naturally, laughter finds its way in, and strangers often leave as friends.
              </p>
              <p className="body-text">
                Whether you’re new to a city, looking to expand your circle, or simply craving honest, engaging conversations, HighTable offers a setting that feels welcoming, real, and deeply human.
              </p>
              <p className="body-text">
                Because sometimes, all it takes is a seat at the right table.
              </p>
              <div className="footer-nav margin-top-desktop-40">
                <Link
                  to={{
                    pathname: "/about-us",
                  }}
                  className="footer-link"
                >
                  About us
                </Link>
                <Link
                  to="/faq"
                  className="footer-link margin-left-desktop-20 margin-top-mobile-10"
                >
                  FAQ's
                </Link>

                <Link
                  to="/contact-us"
                  className="footer-link margin-left-desktop-20 margin-top-mobile-10"
                >
                  Contact us
                </Link>

                <Link
                  to="/privacy"
                  className="footer-link margin-left-desktop-20 margin-top-mobile-10"
                >
                  Privacy
                </Link>
              </div>
            </div>
            <div
              id="w-node-_9398969b-af2d-ac75-94d0-84c151c3bf45-51c3bf2f"
              className="footer-block top-margin-mobile-80"
            >
              <br/>
              <h4 className="footer-heading">Let’s Get Social!</h4>
              <p className="get-the-app-desc">
                Follow us for fun updates, behind-the-scenes vibes, and a dash
                of sass. Let’s make scrolling worth it!
              </p>
              <a
                href="https://www.instagram.com/hightable.irl/"
                className="footer-link mgtop10 flex items-center gap-2"
              >
               <GrInstagram />  
               Instagram
              </a>
              <a
                href="https://www.linkedin.com/company/high-table-irl/"
                className="footer-link mgtop10 flex items-center gap-2"
              >
                <GrLinkedin />
                Linkedin
              </a>
              <a
                href="https://www.facebook.com/people/HighTable/61570316743206/"
                className="footer-link mgtop10 flex items-center gap-2"
              >
                <GrFacebookOption />
                Facebook
              </a>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="body-text">
              © 2024 Hightable Network Private Limited | Designed by{" "}
              <a href="https://kwad.in" className="link">
                Kwad
              </a>
            </p>
            <Link to="/terms" className="footer-link margin-top-mobile-10">
              Terms of service
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
